import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { submitWaterTestFormAsync, submitWaterTestFormAsyncBuilder } from './asyncRequests/submitWaterTestFormAsync';

export interface WaterTestFormState {
  formData: {
    name: string;
    email: string;
    streetName1: string;
    streetName2: string;
    city: string;
    state: string;
    zipCode: string;
    waterSource: 'well' | 'public';
    utility: string;
    newsletter: boolean;
  };
  loading: boolean;
  success: boolean;
  error: {
    message: string;
    errors: Array<{
      field: string;
      message: string;
    }>;
  } | null;
  isSubmitted: boolean;
}

const initialState: WaterTestFormState = {
  formData: {
    name: '',
    email: '',
    streetName1: '',
    streetName2: '',
    city: '',
    state: '',
    zipCode: '',
    waterSource: 'public',
    utility: '',
    newsletter: false,
  },
  loading: false,
  success: false,
  error: null,
  isSubmitted: false,
};

const waterTestFormSlice = createSlice({
  name: 'waterTestForm',
  initialState,
  reducers: {
    updateField: (state, action: PayloadAction<{ field: keyof WaterTestFormState['formData']; value: string }>) => {
      const { field, value } = action.payload;
      (state.formData[field] as string | boolean) = value;
    },
    resetForm: () => initialState,
  },
  extraReducers: (builder) => {
    submitWaterTestFormAsyncBuilder(builder);
  },
});

export const { updateField, resetForm } = waterTestFormSlice.actions;
export const WaterTestFormActions = {
  ...waterTestFormSlice.actions,
  submitWaterTestFormAsync,
};
export const WaterTestFormReducer = waterTestFormSlice.reducer;